var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 104 104"}},[_c('g',{staticClass:"cls-1"},[_c('line',{attrs:{"x1":"52","y1":"4","x2":"52","y2":"100"}}),_c('line',{attrs:{"x1":"22","y1":"6","x2":"82","y2":"6"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }